import { LocalStorageService } from './localStorageService';
import { OauthService } from './oauthService';
import { isValidJsonString, isValidTokenResponse } from './stringHelperService';

const NEW_TOKEN_TIMEOUT = 30000;

export const TokenService = {
	timeOutStore: {},
	validateLocalToken() {
		let lastTokenReceived = LocalStorageService.getLastTokenReceived();
		let accessToken = LocalStorageService.getAccessToken();
		if (lastTokenReceived && accessToken) {
			this.checkTimeOutForToken();
		}
	},

	checkTimeOutForToken() {
		let currentTime = new Date().getTime();
		let lastTokenReceived = LocalStorageService.getLastTokenReceived();
		let secondsLapsed = (currentTime - lastTokenReceived) / 1000;
		let previousExpireTime = LocalStorageService.getExpiresIn();
		let newExpiresTime = 0;
		if (secondsLapsed > 0 && secondsLapsed < Number(previousExpireTime)) {
			if (previousExpireTime && previousExpireTime > secondsLapsed) {
				newExpiresTime = previousExpireTime - secondsLapsed;
				this.triggerTimeOutForNewToken(newExpiresTime);
				return;
			} else {
				this.tryForANewtoken();
			}
		}
	},

	triggerTimeOutForNewToken(time) {
		clearTimeout(this.timeOutStore);
		this.timeOutStore = setTimeout(
			(_) => this.tryForANewtoken(),
			(time - 60) * 1000
		);
	},

	saveTokenTime(expiresIn) {
		let now = new Date().getTime();
		localStorage.setItem('lastTokenReceived', now);
		TokenService.triggerTimeOutForNewToken(expiresIn);
	},

	tryForANewtoken() {
		this.requestNewToken();
	},

	requestNewToken() {
		OauthService.createIframe();
	},

	// Resolves with a freshly minted token and when it dies.
	//
	// The identity server only hands tokens back through a browser navigation (implicit flow puts
	// them in the URL fragment, which no fetch can read), so this drives the same hidden iframe the
	// app already uses and waits for oauth.html to post the result back to us. The app's stored
	// token is refreshed on the way through, so callers do not have to.
	requestFreshToken(timeoutMs = NEW_TOKEN_TIMEOUT) {
		return new Promise((resolve, reject) => {
			let timer = null;

			const cleanUp = () => {
				window.removeEventListener('message', handleMessage);
				clearTimeout(timer);
				const iframe = document.getElementById('oauthFrame');
				if (iframe && iframe.remove) {
					iframe.remove();
				}
			};

			const handleMessage = (event) => {
				if (event.origin !== window.location.origin || !isValidJsonString(event.data)) {
					return;
				}
				const data = JSON.parse(event.data);
				// prompt=none means a dead identity session answers immediately with an error rather
				// than drawing a login form in a frame nobody can see, so surface it instead of
				// sitting here until the timeout.
				if (data && typeof data.error === 'string' && data.state) {
					cleanUp();
					reject(new Error(data.error_description || data.error));
					return;
				}
				if (!isValidTokenResponse(data)) {
					return;
				}
				cleanUp();
				LocalStorageService.updateLocalStorage(data);
				TokenService.saveTokenTime(data.expires_in);
				resolve({
					token: data.access_token,
					expiresAt: Date.now() + Number(data.expires_in) * 1000,
				});
			};

			window.addEventListener('message', handleMessage);
			timer = setTimeout(() => {
				cleanUp();
				reject(new Error('Timed out waiting for a new access token'));
			}, timeoutMs);

			OauthService.createIframe();
		});
	},

	// When the token currently in storage dies, as epoch ms, or null when that is not known
	getStoredTokenExpiresAt() {
		const lastTokenReceived = Number(LocalStorageService.getLastTokenReceived());
		const expiresIn = Number(LocalStorageService.getExpiresIn());
		if (!lastTokenReceived || !expiresIn) {
			return null;
		}
		return lastTokenReceived + expiresIn * 1000;
	},
};
